import styled from '@emotion/styled';
import { Image } from '@qga/roo-ui/components';
import { rooRed } from '@qga/roo-ui/assets';
import { rem } from 'polished';

// Note: Do not show Image on screen which height is less than `598px`.
const StyledLogo = styled(Image)`
  @media (max-height: ${rem('598px')}) {
    display: none;
  }
`;

StyledLogo.displayName = 'StyledLogo';

const Logo = () => (
  <StyledLogo
    alt="Qantas Logo"
    src={rooRed}
    width={[rem('64px'), rem('96px')]}
    height={[rem('55px'), rem('82px')]}
    mb={[8, 11]}
    inline={true}
  />
);

export default Logo;
